import { useState, useRef, useEffect } from "react";
import MedicineBillUi from "./MedicineBillUi";
import { changeDateFormatForServer } from "../../Utils/dateUtils";
import * as toast from "../../Wrapper/toast/toast";
import * as apiHelper from "../../Services/ApiHelper";
import { getPaymodeOptions } from "../../Services/common";
import { useNavigate } from "react-router-dom";
const MedicineBill = () => {
  let navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState("");
  const [loading, setLoading] = useState(false);
  const [medicineBillList, setMedicineBillList] = useState([]);
  const [lastSelectedPage, setLastSelectedPage] = useState(1);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [statusOptions, setStatusOptions] = useState(getPaymodeOptions());
  const [dates, setDates] = useState({ startDate: null, endDate: null });
  const datePickerStartRef = useRef();
  const datePickerEndRef = useRef();

  useEffect(() => {
    if (
      (dates.startDate !== null && dates.endDate !== null) ||
      (dates.startDate === null && dates.endDate === null)
    ) {
      getMedicineBillList(lastSelectedPage);
    }
  }, [dates]);
  const onPageChange = (page) => {
    getMedicineBillList(page);
  };
  const getMedicineBillList = (
    page = 1,
    q = searchQuery,
    newDates = dates,
    options = selectedOptions,
  ) => {
    const filterValue = encodeURIComponent(JSON.stringify(options)); // this gives '["CASH","ONLINE"]'
    const query = {
      page: page,
      q: q,
      filter: options, // assuming filterValue is an array
      start_date: changeDateFormatForServer(newDates.startDate),
      end_date: changeDateFormatForServer(newDates.endDate),
      limit: 10,
    };

    // const query = `?page=${page}&query=${q}&filter=${options}&to_date=${changeDateFormatForServer(newDates.startDate)}&from_date=${changeDateFormatForServer(newDates.endDate)}&limit=10`
    setLastSelectedPage(page);
    setLoading(true);
    apiHelper.getMedicineBillList(query).then((response) => {
      if (response?.isSuccess) {
        setMedicineBillList(response.data);
      } else {
        toast.warn(response?.message);
      }
      setLoading(false);
    });
  };
  const handleDropdownChange = (options) => {
    setSelectedOptions(options);
    getMedicineBillList(lastSelectedPage, searchQuery, dates, options);
  };
  const clearFilter = (e) => {
    const dropdownMenu = e.target.closest("#dropdown-basic");
    dropdownMenu.click();
    e.stopPropagation();
    setSelectedOptions([]);
    getMedicineBillList(1, searchQuery, dates, []);
  };
  const openDetailsPage = (id) => {
    navigate("/purchase-medicines", { state: { id } });
  };

  return (
    <MedicineBillUi
      setSearchQuery={setSearchQuery}
      searchQuery={searchQuery}
      dates={dates}
      setDates={setDates}
      datePickerEndRef={datePickerEndRef}
      datePickerStartRef={datePickerStartRef}
      loading={loading}
      setLoading={setLoading}
      clearFilter={clearFilter}
      setMedicineBillList={setMedicineBillList}
      onPageChange={onPageChange}
      lastSelectedPage={lastSelectedPage}
      setLastSelectedPage={setLastSelectedPage}
      getMedicineBillList={getMedicineBillList}
      medicineBillList={medicineBillList}
      selectedOptions={selectedOptions}
      handleDropdownChange={handleDropdownChange}
      statusOptions={statusOptions}
      openDetailsPage={openDetailsPage}
    />
  );
};
export default MedicineBill;
